module.exports = __webpack_public_path__ + "img/eye-icon.806610ac.svg";